import { render, staticRenderFns } from "./TeamPicker.vue?vue&type=template&id=58a50ec1&scoped=true"
import script from "./TeamPicker.vue?vue&type=script&lang=js"
export * from "./TeamPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a50ec1",
  null
  
)

export default component.exports